import { render, staticRenderFns } from "./Sezyz.vue?vue&type=template&id=d709e9b4&scoped=true&"
import script from "./Sezyz.vue?vue&type=script&lang=js&"
export * from "./Sezyz.vue?vue&type=script&lang=js&"
import style0 from "./Sezyz.vue?vue&type=style&index=0&id=d709e9b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d709e9b4",
  null
  
)

export default component.exports